// Imports
import React from 'react';
import determineHighlightRanges from './determine-highlight-ranges';


// Define the accepted props
interface Props {
	fullText: string;
	query: string;
}


// Function component
const HighlightedText: React.FC<Props> = ({ fullText, query }) => {
	// Initialize
	const ranges = determineHighlightRanges(fullText, query);
	
	
	// Return early
	if (ranges.length === 0) {
		return <React.Fragment>{fullText}</React.Fragment>;
	}
	
	
	// Initialize
	const parts: React.ReactNode[] = [];
	let offset = 0;
	
	
	// Iterate over ranges
	for (const [start, end] of ranges) {
		// Add any preceding text
		if (offset < start) {
			parts.push(fullText.slice(offset, start));
		}
		
		
		// Add highlighted text
		parts.push(<strong key={start}>{fullText.slice(start, end)}</strong>);
		
		
		// Update offset
		offset = end;
	}
	
	
	// Add any following text
	if (offset < fullText.length) {
		parts.push(fullText.slice(offset));
	}
	
	
	// Return
	return <React.Fragment>{parts}</React.Fragment>;
};

export default HighlightedText;
